import ApplyCTA from "@/components/shared/ApplyCTA";

export default function Guarantee() {
  return (
    <section id="guarantee" className="access-section bg-room-2 border-y border-soft">
      <div className="access-container max-w-3xl">
        <span className="mono-label mono-label-gold">How we work</span>
        <h2 className="h-section mt-5">
          We don't run on <span style={{ color: "var(--gold-strong)" }}>a clock.</span>
        </h2>
        <div className="mt-10 space-y-6 body-lg">
          <p>Most programs hand you a login, run you for 90 days, and then you're on your own. Ready or not. Placed or not.</p>
          <p>We don't work like that. Getting good enough to get on a real offer takes what it takes. For some people that's a few months. For some it's longer. The reps decide, not a calendar.</p>
          <p>So the room doesn't expire on you. The trainings, the framework library, the AI drills, the network, and the line to real offers stay open while you're still building. We're not trying to get you to day 90. We're trying to get you closing.</p>
          <p className="text-bone">I'm not going to promise you a placement date. Nobody honest can. What I'll tell you is this: we keep working with you until you can walk onto a real offer and hold your own. That part I can stand behind.</p>
        </div>
        <div className="mt-10">
          <ApplyCTA />
        </div>
      </div>
    </section>
  );
}
